import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs';

/**
 * Action to propagate the remove rows from listview store
 * @param rowKeys - the rows keus
 * @param tableView - the current tableView
 */
export default action(
    'REMOVE_ROWS_FROM_LISTVIEW_STORE',
    (rowKeys: string[], tableView: TableView) => {
        return {
            rowKeys,
            tableView,
        };
    }
);
